import { computed, ref } from 'vue'
import { usePage } from '@inertiajs/vue3'

export function useHeaderBanners() {
  const banners = ref(usePage().props.header.banners)

  const updateBanner = (banner, data) => {
    banners.value[banner] = data
  }

  const liveEventBanner = computed(() => banners.value['live-event'])

  return {
    updateBanner,
    liveEventBanner
  }
}
